import { Spinner, SpinnerSize } from '@fluentui/react';
import React from 'react';
import { useTranslation } from '../../Locales/i18n/localizationService';

export const PFSpinner = (props: { LabelText?: string; CustomClass?: string }) => {
    const { t } = useTranslation();
    return (
        <Spinner size={SpinnerSize.large} label={props.LabelText ?? t('Common.LoadingDot')} className={`${props.CustomClass ? 'customClass' : 'tp-spinner'}`} />
    );
};
